import {
    DashboardMenuItem,
    getResources,
    MenuItemLink,
    MenuProps,
    ReduxState,
    toggleSidebar,
    useTranslate
} from "react-admin";
import logo from "./assets/logo.png";

import {Fragment, useCallback, useEffect, useMemo, useState} from "react";
import LabelIcon from "@material-ui/icons/Label";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import classnames from "classnames";
import classNames from "classnames";
import DefaultIcon from "@material-ui/icons/ViewList";

import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import Tooltip from "@material-ui/core/Tooltip";
import {makeStyles} from "@material-ui/styles";

const useStylesMenuItem = makeStyles<any>(
  (theme) => ({
    endIcon: {
      minWidth: theme.spacing(1),
      color: theme.palette.text.secondary,
      transition: theme.transitions.create(["color", "transform"], {
        duration: theme.transitions.duration.shortest,
      }),
    },
    icon: {
      minWidth: theme.spacing(4),
      color: "inherit",
    },
    sidebarIsOpen: {
      "& a": {
        minHeight: 32,
        paddingLeft: theme.spacing(4.25),
        paddingRight: theme.spacing(1),
        transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
      },
      "& .RaMenuItemLink-icon": {
        minWidth: theme.spacing(4),
      },
    },
    sidebarIsClosed: {
      "& a": {
        minHeight: 28,
        paddingLeft: theme.spacing(1.25),
        transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
      },
    },
    menuItem: {
      minHeight: 28,
      margin: 0,
      padding: theme.spacing(0.15, 0.5),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.secondary,
      "&:hover": {
        backgroundColor: "rgba(244, 67, 54, 0.08)",
        color: theme.palette.text.primary,
      },
    },
    parentMenuItem: {
      minHeight: 32,
      margin: theme.spacing(0.3, 0.5),
      padding: theme.spacing(0.25, 0.75),
    },
    menuItemName: {
      flex: "1 auto",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: "0.82rem",
      fontWeight: 600,
    },
    betaBadge: {
      marginRight: theme.spacing(0.75),
      padding: theme.spacing(0.1, 0.6),
      borderRadius: theme.shape.borderRadius,
      backgroundColor: "#f57c00",
      color: theme.palette.common.white,
      fontSize: "0.62rem",
      fontWeight: 700,
      letterSpacing: "0.04em",
      lineHeight: 1.4,
      textTransform: "uppercase",
    },
    openMenuItem: {
      backgroundColor: "rgba(244, 67, 54, 0.1)",
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: "rgba(244, 67, 54, 0.14)",
      },
      "& $endIcon": {
        color: theme.palette.primary.main,
      },
    },
    activeBranchMenuItem: {
      backgroundColor: "rgba(244, 67, 54, 0.06)",
      color: theme.palette.primary.main,
      boxShadow: "inset 3px 0 0 rgba(244, 67, 54, 0.75)",
      "&:hover": {
        backgroundColor: "rgba(244, 67, 54, 0.1)",
      },
      "& $endIcon": {
        color: theme.palette.primary.main,
      },
    },
    childrenList: {
      margin: theme.spacing(0, 0.5, 0.25),
      paddingLeft: theme.spacing(0.75),
      borderLeft: "1px solid rgba(0, 0, 0, 0.08)",
    },
    nestedChildrenList: {
      margin: theme.spacing(0, 0.5, 0.25),
      paddingLeft: theme.spacing(1),
      borderLeft: "1px solid rgba(244, 67, 54, 0.18)",
    },
    nestedItem: {
      position: "relative",
      "&::before": {
        content: '""',
        position: "absolute",
        left: -8,
        top: "50%",
        width: 5,
        height: 1,
        backgroundColor: "rgba(244, 67, 54, 0.24)",
      },
    },
    leafLink: {
      "& .MuiListItemIcon-root": {
        minWidth: theme.spacing(4),
      },
    },
    leafLinkClosed: {
      fontSize: 0,
      paddingLeft: theme.spacing(0.75),
      paddingRight: theme.spacing(0.5),
      "& .MuiListItemIcon-root": {
        minWidth: theme.spacing(3.5),
        marginRight: theme.spacing(0.5),
      },
    },
  }),
  { name: "RaTreeCustomMenuItem" }
);

const CustomMenuItem = ({
  handleToggle,
  sidebarIsOpen,
  isOpen,
  isActiveBranch,
  isNested,
  isLeaf,
  name,
  icon,
  children,
  dense,
  isBeta,
}: any) => {
  const classes = useStylesMenuItem();
  const translate = useTranslate();



  const header = (
    <MenuItem
      key={name}
      dense={dense}
      button
      onClick={handleToggle}
      className={classnames(classes.menuItem, {
        [classes.parentMenuItem]: !isNested,
        [classes.openMenuItem]: isOpen,
        [classes.activeBranchMenuItem]: isActiveBranch && !isOpen,
        [classes.nestedItem]: isNested,
      })}
    >
      <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
      <Typography
        variant="inherit"
        className={classnames(classes.menuItemName, "menuItemName")}
      >
        {translate(name)}
      </Typography>
      {isBeta && <span className={classes.betaBadge}>Beta</span>}
      {isOpen ? (
        <ExpandLess className={classes.endIcon} />
      ) : (
        <ExpandMore className={classes.endIcon} />
      )}
    </MenuItem>
  );

  return (
    <Fragment>
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        <Tooltip title={translate(name)} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <List
        dense={dense}
        component="div"
        disablePadding
        className={classnames(
          sidebarIsOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed,
          isNested ? classes.nestedChildrenList : classes.childrenList
        )}
        style={{
          display: "flex",
          flexDirection: "column",
            alignItems: "left",
          }}
        >
          {children}
        </List>
      </Collapse>
    </Fragment>
  );
};

const useStyles = makeStyles<any>(
  (theme) => ({
    main: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      boxSizing: "border-box",
      minHeight: "100%",
      padding: theme.spacing(1, 0, 2),

      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    open: {
      width: 200,
    },
    closed: {
      width: 55,
    },
    menuButton: {
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: theme.spacing(1.5),
      cursor: "pointer",
      display: "block",
    },
    menuButtonIconClosed: {
      transition: theme.transitions.create(["transform"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      transform: "rotate(0deg)",
    },
    menuButtonIconOpen: {
      transition: theme.transitions.create(["transform"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      transform: "rotate(360deg)",
    },
    menuContent: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(0.5),
    },
    subParentWrapper: {
      paddingLeft: theme.spacing(1.5),
    },
  }),
  { name: "RaTreeMenu" }
);

export const CustomMenuTree = (props: MenuProps) => {
  const {
    className,
    dense = true,
    hasDashboard,
    onMenuClick,
    logout,

    ...rest
  } = props;


  const classes = useStyles(props);
  const translate = useTranslate();
  const open = useSelector((state: ReduxState) => state.admin.ui.sidebarOpen);
  const pathname = useSelector(
    (state: ReduxState) => state.router.location.pathname
  );
  const resources = useSelector(getResources, shallowEqual) as Array<any>;
  const [state, setState] = useState<any>(undefined);
  let treeStructure: { [key: string]: any } = {};

  for (let i = 0; i < resources.length; i++) {
    let parent = resources[i].options.menuParent ? resources[i].options.menuParent : null;
    let name = resources[i].name as string;
    if (parent === null) {
      treeStructure[name] = null;
    }
    else {
      if (!(name in treeStructure)) {
        treeStructure[name] = [parent];
      }
      else {
        if (!treeStructure[name].includes(parent)) {
          treeStructure[name].push(parent);
        }
      }
    }
  }
  let foundChange = false;
  do {
    foundChange = false;
    for (let name in treeStructure) {
      if (treeStructure[name] === null) {
        continue;
      }
      for (let parent of treeStructure[name])
        if (parent in treeStructure && treeStructure[parent] !== null) {
          for (let p of treeStructure[parent]) {
            if (!treeStructure[name].includes(p)) {
              treeStructure[name].push(p);
              foundChange = true;
            }
          }
        }
    }
  } while (foundChange);

  const hasList = (resource: any) => resource.hasList;
  const dispatch = useDispatch();

  const isParent = (resource: any) =>
    /**
     * Check if the given resource is a parent
     * i.e. dummy resource for menu parenting
     */
    resource.options &&
    resource.options.hasOwnProperty("isMenuParent") &&
    !resource.options.hasOwnProperty("menuParent") &&
    resource.options.isMenuParent;

  const isSubParent = (resource: any) =>
    /**
     * Check if the given resource is a parent
     * i.e. dummy resource for menu parenting
     */
    resource.options &&
    resource.options.hasOwnProperty("isMenuParent") &&
    resource.options.hasOwnProperty("menuParent") &&
    resource.options.isMenuParent;


  const isOrphan = (resource: any) =>
    /**
     * Check if the given resource is an orphan
     * i.e. has no parents defined. Needed as
     * these resources are supposed to be rendered
     * as is
     *
     */
    resource.options &&
    !resource.options.hasOwnProperty("menuParent") &&
    !resource.options.hasOwnProperty("isMenuParent");

  const isChildOfParent = (resource: any, parentResource: any) =>
    /**
     * Returns true if the given resource is the
     * mapped child of the parentResource
     */
    resource.options &&
    resource.options.hasOwnProperty("menuParent") &&
    resource.options.menuParent === parentResource.name;
  const geResourceName = (slug: string) => {
    if (!slug) return;
    var words = slug.toString().split("_");
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      words[i] = word.charAt(0).toUpperCase() + word.slice(1);
    }
    return words.join(" ");
  };

  const getPrimaryTextForResource = (resource: any) => {
    let resourcename: any = "";
    if (resource.options && resource.options.label)
      resourcename = resource.options.label;
    else if (resource.name) {
      resourcename = translate(`resources.${resource.name}.name`);
      if (resourcename.startsWith("resources."))
        resourcename = geResourceName(resource.name);
    }
    return resourcename;
  };

  const isActivePath = (resource: any) =>
    resource.name &&
    (pathname === `/${resource.name}` ||
      pathname.startsWith(`/${resource.name}/`));

  const activeResourceName = useMemo(() => {
    const activeResource = resources.find(isActivePath);
    return activeResource ? activeResource.name : null;
  }, [pathname, resources]);

  const visibleState = state === undefined ? activeResourceName : state;

  const isResourceInParentStack = (resourceName: any, parentName: string) =>
    Array.isArray(treeStructure[resourceName]) &&
    treeStructure[resourceName].includes(parentName);

  const isMenuOpenFor = (parentResource: any, currentState: any) =>
    currentState !== null &&
    currentState !== undefined &&
    (
      currentState === parentResource.name ||
      isResourceInParentStack(currentState, parentResource.name)
    );

  const isActiveBranchFor = (parentResource: any) =>
    activeResourceName !== null &&
    activeResourceName !== parentResource.name &&
    isResourceInParentStack(activeResourceName, parentResource.name);

  const handleToggle = (parent: any) => {
    if (isParent(parent) || isSubParent(parent)) {
      setState((currentState: any) => {
        const currentVisibleState = currentState === undefined ? activeResourceName : currentState;
        if (!isMenuOpenFor(parent, currentVisibleState)) {
          return parent.name;
        }

        if (isSubParent(parent)) {
          return parent.options.menuParent;
        }

        return null;
      });
      return;
    }
    setState(parent.name);
  };

const MenuItem = (resource: any) => (
    /**
     * Created and returns the MenuItemLink object component
     * for a given resource.
     */
    (() => {
      const label = getPrimaryTextForResource(resource);
      return (
    <MenuItemLink
      key={resource.name}
      to={`/${resource.name}`}
      primaryText={open ? label : ""}
      leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
      onClick={() => {
        setState(resource.name);
      }}
      dense={dense}
      sidebarIsOpen={open}
      tooltipProps={!open ? ({ title: label } as any) : undefined}
      className={classnames(classes.leafLink, {
        [classes.leafLinkClosed]: !open,
      })}
    />
      );
    })()
  );

  /**
   * Mapping a "parent" entry and then all its children to the "tree" layout
   */
  const mapParentStack = (parentResource: any) => (
    <CustomMenuItem
      key={parentResource.name}
      handleToggle={() => handleToggle(parentResource)}
      isOpen={isMenuOpenFor(parentResource, visibleState)}
      isActiveBranch={isActiveBranchFor(parentResource)}
      isNested={isSubParent(parentResource)}
      sidebarIsOpen={open}
      name={getPrimaryTextForResource(parentResource)}
      icon={
        parentResource.icon ? (
          <parentResource.icon fontSize={"small"} />
        ) : (
          <LabelIcon fontSize={"small"} />
        )
      }
      dense={dense}
      isBeta={parentResource.options.beta}
    >
      {
        // eslint-disable-next-line
        resources
          .filter(
            (resource) =>
              isChildOfParent(resource, parentResource)// && hasList(resource)
          )
          .map((childResource) => {
            //return MenuItem(childResource);
            if (childResource.options.isMenuParent === true) {
              return <div key={childResource.name} className={classes.subParentWrapper}>
                {mapParentStack(childResource)}
              </div>

            }
            if (hasList(childResource)) {
              return MenuItem(childResource);
            }
            return null
          })
      }
    </CustomMenuItem >
  );

  /**
   * Mapping independent (without a parent) entries
   */
  const mapIndependent = (independentResource: any) =>
    hasList(independentResource) && MenuItem(independentResource);

  useEffect(() => {
    if (state === undefined && activeResourceName) {
      setState(activeResourceName);
    }
  }, [activeResourceName, state]);

  useEffect(() => {
    const activeResource = resources.find(isActivePath);

    if (!activeResource || !activeResource.options) {
      document.title = "Spsweb";
      return;
    }

    const finalPart = document.location.pathname.split("/").pop();
    const label = activeResource.options.label;

    if (document.location.pathname.includes("create")) {
      document.title = label ? `${label}: New` : "Spsweb";
    } else if (
      document.location.pathname.includes("edit") ||
      (finalPart && !isNaN(parseInt(finalPart.toString())))
    ) {
      document.title = label ? `${label}: ${finalPart}` : "Spsweb";
    } else {
      document.title = label || "Spsweb";
    }
  }, [pathname, resources]);

  const handleKeyPress = useCallback((event) => {
    if (event.shiftKey === true && event.ctrlKey === true && event.key === "N") {
      window.location.href = window.location.origin + "/deliveries/create";
    }
    else if (event.shiftKey === true && event.ctrlKey === true && event.key === "M") {
      window.location.href = window.location.origin + "/deliveries";
    }
    else if (event.shiftKey === true && event.ctrlKey === true && event.key === "S") {
      window.location.href = window.location.origin + "/subjects";
    }
    else if (event.shiftKey === true && event.ctrlKey === true && event.key === "G") {
      window.location.href = window.location.origin + "/routes";
    }
    else if (event.shiftKey === true && event.ctrlKey === true && event.key === "C") {
      window.location.href = window.location.origin + "/cachets";
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);

  /**
   * The final array which will hold the array
   * of resources to be rendered
   */
  const resRenderGroup: any = [];

  /**
   * Looping over all resources and pushing the menu tree
   * for rendering in the order we find them declared in
   */
  resources.forEach((r) => {
    if (isParent(r)) resRenderGroup.push(mapParentStack(r));
    if (isOrphan(r)) resRenderGroup.push(mapIndependent(r));
  });

  return (
    <div>
      <div
        className={classnames(classes.main, className, {
          [classes.open]: open,
          [classes.closed]: !open,
        })}
        {...rest}
      >
        <Tooltip
          title={translate(
            open ? "ra.action.close_menu" : "ra.action.open_menu",
            {
              _: "Open/Close menu",
            }
          )}
          enterDelay={500}
        >
          <img
            src={logo}
            alt="logo supersonica"
            width="35px"
            onClick={() => dispatch(toggleSidebar())}
            className={classNames(
              classes.menuButton,
              open ? classes.menuButtonIconOpen : classes.menuButtonIconClosed
            )}
          />
        </Tooltip>
        {hasDashboard && (
          <DashboardMenuItem
            onClick={onMenuClick}
            dense={dense}
            sidebarIsOpen={open}
          />
        )}
        <div className={classes.menuContent}>{resRenderGroup}</div>
      </div>
    </div>
  );
};
